module.exports = __webpack_public_path__ + "media/images/landing/USA-matrimony-banner3_1200-bad99e483aed4676f0b58bd1af7732c9.webp";